export const achievementsData = [{
    class: 'small-box',
    content: "Top 30 Walmart CodeHers 22'."
}, {
    class: 'extra-small-box',
    content: "3 &#9734; on Leetcode."
}, {
    class: 'big-box',
    content: 'First Prize in Hack4Women hackathon conducted by GirlScript Foundation.'
}, {
    class: 'small-box',
    content: "6 &#9734; on HackerRank problem solving."
}, {
    class: 'small-box',
    content: 'Pre finalist in Uber HackTag 2.0.'
}, {
    class: 'small-box',
    content: 'Pre finalist in ION<athon> 1.0.'
}];